import resume from "../assets/pdf/resume.pdf";
import profileImg from "../assets/png/Venky.jpg";

export const headerData = {
  name: "Venkatesulu",
  title: "Web Developer",
  desciption:
    "",
  image: profileImg,
  resumePdf: resume,
};

// import resume from "../assets/pdf/resume.pdf";
// import profileImg from "../assets/png/profileImg.png";

// export const headerData = {
//   name: "Renuka Prasad",
//   title: "Web Developer",
//   description:
//     "feet on the ground, eyes at the sky, never stop dreaming, never till you die, spread your wings, and fly high",
//   image: profileImg,
//   resumePdf: resume,
// };
